import React from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";


const DeleteDialog = ({
  open,
  row,
  onClose,
  onConfirm,
}) => {

  return (
    <Dialog
      open={open}
      onClose={onClose}
    >

      <DialogTitle>
        Confirm Delete
      </DialogTitle>


      <DialogContent>

        <Typography>
          Are you sure you want to delete entry for{" "}
          <strong>
            {row?.name || "this customer"}
          </strong>
        </Typography>


        <Typography
          sx={{ mt: 1 }}
          color="text.secondary"
        >
          This action cannot be undone.
        </Typography>


      </DialogContent>


      <DialogActions>

        <Button
          onClick={onClose}
        >
          Cancel
        </Button>


        <Button
          color="error"
          variant="contained"
          onClick={onConfirm}
        >
          Delete
        </Button>


      </DialogActions>

    </Dialog>
  );
};


export default DeleteDialog;